var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHearth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91301 13.8733C8.68634 13.9533 8.31301 13.9533 8.08634 13.8733C6.15301 13.2133 1.83301 10.46 1.83301 5.79332C1.83301 3.73332 3.49301 2.06665 5.53967 2.06665C6.75301 2.06665 7.82634 2.65332 8.49967 3.55998C9.17301 2.65332 10.253 2.06665 11.4597 2.06665C13.5063 2.06665 15.1663 3.73332 15.1663 5.79332C15.1663 10.46 10.8463 13.2133 8.91301 13.8733Z",
    stroke: "#00a14b",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearth);
export default __webpack_public_path__ + "static/media/hearth.a1b0d759abcf4a7988fefa4a8e26528f.svg";
export { ForwardRef as ReactComponent };